import { GET_RESIDENCE_CLOTH_LIST_FAILURE, GET_RESIDENCE_CLOTH_LIST_SUCCESS } from '../constants/MTag';
import { onFailure, onSuccess } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_RESIDENCE_CLOTH_LIST_SUCCESS:
			return onSuccess(state, action);
		case GET_RESIDENCE_CLOTH_LIST_FAILURE:
			return onFailure(state, action);
		default:
			return { ...state };
	}
};
